import React from "react";
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";
import Grid from "@mui/material/Unstable_Grid2";
import { useNavigate } from "react-router-dom";
import { Link } from "@mui/material";

function SpocContact() {
  const navigate = useNavigate();
  const [officeselectspoc, setOfficeSelectSpoc] = React.useState("");
  const spoc_data = [
    {
      label: "EV1012152 - Kartike Kakkar-Evervent",
      value: "EV1012152 - Kartike Kakkar-Evervent",
    },
    {
      label: "EV1252524 - Vikas Saini-TCS",
      value: "EV1252524 - Vikas Saini-TCS",
    },
    {
      label: "EV1241421 - Rahul Raghuvanshi-Google",
      value: "EV1241421 - Rahul Raghuvanshi-Google",
    },
    {
      label: "EV1241423 - Rohit Manokotia-Meta",
      value: "EV1241423 - Rohit Manokotia-Meta",
    },
    {
      label: "EV1241422 - Udit Jaswal-Linked In",
      value: "EV1241422 - Udit Jaswal-Linked In",
    },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  return (
    <div>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <h5 className="mb-0 subHeading">SPOC Info</h5>
        </Grid>
        <Grid xs={4}>
          <SelectDropdown
            class_name="inputField"
            title="Select SPOC"
            value={officeselectspoc}
            attrName={setOfficeSelectSpoc}
            value_update={updateMasterState}
            dropdown_data={spoc_data}
            warn_status={false}
          />
        </Grid>
        <Grid xs={3} className="mt-2">
          OR
          <Link
            className="greenBtn addfile"
            underline="none"
            onClick={() => {
              navigate("/AddNewContact");
            }}
          >
            Create New Contact
          </Link>
        </Grid>
      </Grid>
    </div>
  );
}

export default SpocContact;
